<template>
  <div class="p-4">
    <div class="row transaction-wrapper">
      <h5 class="mb-3">{{ $t("transaction-log") }}</h5>
      <InfoItem
        v-if="transactionData?.collectionId"
        :label="$t('entity-id')"
        :value="transactionData.collectionId"
      />
      <InfoItem
        v-if="transactionData?.user?.userName"
        :label="$t('username')"
        :value="transactionData?.user?.userName"
      />
      <InfoItem
        v-if="transactionData?.user?.role"
        :label="$t('role')"
        :value="$store.getters['enums/roles_enums'].find(each => each.value === transactionData?.user?.role)?.text"
      />
      <InfoItem
        v-if="transactionData?.branch"
        :label="$t('branch')"
        :value="$store.getters['enums/branch_enums'].find(each => each.value === transactionData?.user?.branch)"
      />
      <InfoItem
        v-if="transactionData?.modelName"
        :label="$t('entity')"
        :value="transactionData?.modelName"
      />
      <InfoItem
        v-if="transactionData?.op"
        :label="$t('action')"
        :value="transactionData.op"
      />
      <InfoItem
        v-if="transactionData?.createdAt"
        :label="$t('date')"
        :value="formatDate(transactionData.createdAt)"
      />
    </div>
    <div class="mt-4">
      <div class="mt-3">
        <pre class="direction-ltr">{{ prettyJson }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import InfoItem from "./InfoItem.vue";

export default {
  name: "TransactionDetails",
  props: ["transactionData"],
  components: {
    InfoItem,
  },
  computed: {
    prettyJson() {
      const dataObj = this.transactionData.op === "create" ? this.transactionData?.doc : this.transactionData?.patch;
      return JSON.stringify(dataObj, null, 2);
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).locale("en").format("DD-MM-YYYY HH:mm");
    },
  }
};
</script>

<style lang="scss" scoped>
.transaction-wrapper {
  row-gap: 14px;
}
pre {
  background-color: #f4f4f4;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow-x: auto;
  font-size: 14px;
  font-family: "Courier New", Courier, monospace;
}
</style>
